import Vue from 'vue';

import { END_POINTS } from '@/enums';

import API from './index';

const END_POINT = END_POINTS.EVENTS;

export default {
  async submitInitiateCheckout(requestModel: InitiateCheckoutRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/initiate-checkout`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/initiate-checkout`, err.response);
      throw err.response;
    }
  },
  async submitViewContent(requestModel: ViewContentRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/view-content`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/view-content`, err.response);
      throw err.response;
    }
  },
  async submitPurchase(requestModel: InitiatePurchaseRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/purchase`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/view-purchase`, err.response);
      throw err.response;
    }
  }
}
